import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import dartslogo from "./dartslogo.png";
import "./LoginPage.css";
import { CircularProgress, InputAdornment, TextField } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const LoginPage = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [authenticating, setAuthenticating] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Fixed: Correctly declare state
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      dispatch({ type: "SET_AUTHTOKEN", payload: token });
      dispatch({ type: "SET_ISAUTHENTICATED", payload: true });
      navigate("/homepage");
    }
  }, [dispatch, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setAuthenticating(true);

    try {
      const url = `https://idartsuat.com/api/eodanalytics/Users/authenticate?username=${userName}&password=${password}`;
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: userName, password }),
      };

      const response = await fetch(url, requestOptions);
      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", JSON.stringify(data));
        dispatch({ type: "SET_ISAUTHENTICATED", payload: true });
        dispatch({ type: "SET_AUTHTOKEN", payload: data });
        navigate("/homepage");
      } else {
        setErrorMessage(data.message || "Authentication failed");
        dispatch({ type: "SET_ISAUTHENTICATED", payload: false });
      }
    } catch (error) {
      console.error("Error during authentication:", error);
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setAuthenticating(false);
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword); // Toggle the state
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <img src={dartslogo} alt="dartslogo" width={150} className="logo" />
        <h2>Sign in</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="UserName">UserName:</label>
            <TextField
              id="UserName"
              name="UserName"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Enter Username"
              fullWidth
              variant="outlined"
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <TextField
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter Password"
              fullWidth
              variant="outlined"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <button
                      type="button"
                      onClick={handleClickShowPassword}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </button>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <button
            type="submit"
            disabled={authenticating}
            className="login-button"
          >
            Sign In {authenticating && <CircularProgress size={15} />}
          </button>
          {errorMessage && <p>{errorMessage}</p>}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
